import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("userToken"); // التوكن اللي بيحدد تسجيل الدخول

  if (!token) {
    alert("Please login first!"); // رسالة للمستخدم
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children; // لو مسجل دخول، اعرض المحتوى
};

export default PrivateRoute;
